import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

// Fade + upward reveal, triggered on scroll into view
export const Reveal = ({ children, delay = 0, y = 26, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easeOut, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Section eyebrow with chapter number
export const Eyebrow = ({ chapter, children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {chapter && <span className="eyebrow opacity-60">{chapter}</span>}
    {chapter && <span className="h-px w-6 bg-gold/50" />}
    <span className="eyebrow">{children}</span>
  </div>
);
